import React from "react";
import { Checkbox } from "antd";
import { Icon } from "Components";
import { CheckboxChangeEvent } from "antd/lib/checkbox";

interface Props {
  disableSelection: boolean;
  organizationSelected: boolean;
  setOrganizationSelected: (value: boolean) => void;
  organizationUsers: number
}

const OrganizationRecipients: React.FC<Props> = ({
  disableSelection,
  organizationSelected,
  setOrganizationSelected,
  organizationUsers
}) => {
  const disabled = (!organizationUsers || disableSelection);
  
  const handleOrgSelect = (event: CheckboxChangeEvent | null) => {
    if(event) event.stopPropagation();
    if(disabled) return;
    setOrganizationSelected(!organizationSelected);
  }

  return (
    <div className="phishing-step3__organization">
      <div className="phishing-step3__label">
        Organization <span className="required">*</span>
      </div>

      <div className="phishing-step3__org-box" onClick={() => handleOrgSelect(null)}>
        <Checkbox disabled={disabled} checked={organizationSelected} onChange={handleOrgSelect} />
        <div className="phishing-step3__org-info">
          <div className="phishing-step3__org-title">
            <Icon type="recipientBuilding" /> Entire organization
          </div>
          <span className="phishing-step3__org-count">{organizationUsers} {`user${organizationUsers > 1 ? 's' : ''}`}</span>
        </div>
      </div>
    </div>
  );
};

export default OrganizationRecipients;